import { useMutation } from "react-query";
import { addEmployeeTitle } from "../../../../../actions/Utilities/EmployeeTitle";

const useAddEmailDomain = () => {
    return useMutation(addEmployeeTitle);
  };
  export default useAddEmailDomain;